/**
 * Lead Scoring "Job title screening" tab strings (PREC-3536 Phase 3), plus the Lead Scoring
 * tab-strip labels (moved out of `en.ts` to keep that file under the 500-line ratchet). Spread
 * into `leadScoring` in `en.ts` via `...enLeadScoringTitles`.
 */
export const enLeadScoringTitles = {
	uncoveredSeniorityWarning:
		"These seniority levels are not scored by any column, so leads with them earn no points here: {{levels}}. Add them to a column to score those leads.",
	duplicateBucketWarning:
		"This description says the same thing as another column of this criterion, so the AI cannot tell them apart and may award the wrong score. Describe what makes this column different.",
	stepper: {
		company: "Company Segments",
		prospect: "Persona Segments",
		scoring: "Lead Scoring",
		overview: "Overview",
		general: "General settings",
		"job-titles": "Job title screening",
		changelog: "Change log",
	},
	jobTitles: {
		subtitle:
			"Every job title your workspace has judged against your personas. Whitelisted titles are enriched; excluded titles are set aside during screening. Move a title to correct it — the change is reused on every future list.",
		searchPlaceholder: "Search job titles…",
		whitelistColumn: "Whitelisted job titles",
		excludedColumn: "Excluded job titles",
		addPlaceholder: "Add a title and press Enter",
		exclude: "Exclude",
		whitelist: "Whitelist",
		remove: "Remove",
		manualLabel: "Added manually",
		selected: "{{count}} selected",
		moveToExcluded: "Move to excluded",
		moveToWhitelisted: "Move to whitelisted",
		clearSelection: "Clear",
		prefill: "Pre-fill from persona segments",
		emptyTitle: "No screened job titles yet",
		emptyBody:
			"Titles land here automatically as your lists are screened. To start with a sensible set, pre-fill from the job titles on your persona segments.",
		emptyPrefill: "Pre-fill from your persona segments",
		loadError: "Could not load your job titles. Please try again.",
	},
};
